import { useEffect } from 'react';
import { NavigationType, useLocation, useNavigationType } from 'react-router';

import { useIsFirstRenderRef } from '#/hooks/useIsFirstRenderRef';
import { useIsInEmbedSearchWidget } from '#/modules/embedSearchWidget/hooks/useIsInEmbedSearchWidget';
import { postEmbedSearchWidgetMessage } from '#/modules/embedSearchWidget/utils/postEmbedSearchWidgetMessage';
import { HORIZON_ENABLED } from '#/rendering/state/renderingState';
import { trackEvent } from '#/utils/analytics/track/trackEvent';
import { highlightElement } from '#/utils/highlightElement';

export function RenderingClientLocationHooks() {
  const location = useLocation();
  const navigationType = useNavigationType();

  const { isInEmbedSearchWidget } = useIsInEmbedSearchWidget();
  const { isFirstRenderRef } = useIsFirstRenderRef();

  useEffect(() => {
    if (
      !isFirstRenderRef.current &&
      navigationType !== NavigationType.Replace
    ) {
      trackEvent('JS Page View');
    }
  }, [isFirstRenderRef, navigationType]);

  useEffect(() => {
    if (isInEmbedSearchWidget) {
      if (!isFirstRenderRef.current) {
        postEmbedSearchWidgetMessage({ type: 'idealist-scroll-top' });
      }

      return;
    }

    if (navigationType !== NavigationType.Push) return;

    // When clicking a href=#... we want to always scroll to it even if the same hash was already set
    if (location.hash) {
      const target = document.getElementById(location.hash.substring(1));
      if (target) {
        highlightElement(target);
        return;
      }
    }

    // Horizon uses <ScrollRestoration />
    if (!HORIZON_ENABLED)
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [isInEmbedSearchWidget, isFirstRenderRef, location, navigationType]);

  return null;
}
